import { armorAPI } from '~/services/api';
import { JSONLineItemPayload } from '~/types/LineItem';

export function deleteLineItem(id: string, orderId: string) {
  return armorAPI.request({
    url: `/orders/${orderId}/line_items/${id}`,
    method: 'DELETE',
  });
}

export function editLineItem(id: string, orderId: string, lineItem: JSONLineItemPayload) {
  return armorAPI.request({
    url: `/orders/${orderId}/line_items/${id}`,
    method: 'PUT',
    data: { ...lineItem },
  });
}

export function createLineItem(orderObjectId: string, lineItemPayload: JSONLineItemPayload) {
  return armorAPI.request({
    url: `/orders/${orderObjectId}/line_items`,
    method: 'POST',
    data: {
      ...lineItemPayload,
    },
  });
}
